/* eslint-disable etc/no-commented-out-code */
import { useEffect, useState } from "react";
import useIsMobile from "../utils/detectDevice";
import FlyoutSwitch from "./FlyoutSwitch";
import { FlyoutMobileProfile } from "./FlyoutMobileprofile";
import { SwitchCompanyDropdown } from "./TopBar/Components/companyDropdown";
import FlyoutSettings from "./FlyoutSettings";
import { useAuthStore } from "../store";
import { useGetPlatformInfo } from "../queries/idServer";
import { FlyoutProfile } from "./TopBar/Components/FlyoutProfile";
import { SwitchProduct } from "./TopBar/Components/SwitchPlatform";

function MobileNavBarV2({
  routes,
}: {
  routes: {
    title: string;
    path: string;
    subRoute: string;
    shouldBeDisplayed: boolean;
  }[];
}) {
  const [dialogOpen, setDialogOpen] = useState<{
    mode: "switch";
    open: boolean;
  }>();
  const { isMobile } = useIsMobile();

  const { accessToken } = useAuthStore();
  const { data: userPlatformData } = useGetPlatformInfo(
    accessToken || "",
    accessToken !== undefined && accessToken !== ""
  );

  const [platformData, setPlatformData] = useState<any>(null);
  const [profilePicUrl, setProfilePicUrl] = useState("");

  useEffect(() => {
    if (userPlatformData) {
      setPlatformData(userPlatformData);
      setProfilePicUrl(
        userPlatformData?.find(
          (platformData: { platform: string }) =>
            platformData.platform?.toLowerCase() === "esop"
        )?.profilePicUrl || ""
      );
    }
  }, [userPlatformData]);

  const accessiblePlatforms = Array.from(
    new Set(
      platformData
        ?.filter(
          (platform: any) =>
            platform.data.access && platform.platform !== "esop"
        )
        .map((platform: any) => platform.platform)
    )
  );

  return (
    <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 shadow-sm border-gray-200 sm:gap-x-6 bg-white w-1/ justify-end">
      <SwitchCompanyDropdown />
      <div
        className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200"
        aria-hidden="true"
      />
      <div className="md:block">
        {accessiblePlatforms.length > 0 && (
          <SwitchProduct data={platformData} />
        )}
      </div>
      <div className="md:block">
        <FlyoutProfile profilePicUrl={profilePicUrl} />
      </div>
    </div>
  );
}
export default MobileNavBarV2;
